export default [
    {
        path: '/master/organizations',
        name: 'organizations',
        props: true,
        component: () => import('@/views/master/organizations/index.vue'),
        meta: {
            pageTitle: 'Organizations',
            breadcrumb: [
                {
                text: 'Organizations',
                active: true,
                },
            ],
        },
    },
    {
        path: '/master/organizations/add',
        name: 'create-organizations',
        component: () => import('@/views/master/organizations/create.vue'),
        meta: {
            pageTitle: 'Create Organization',
            breadcrumb: [
                {
                text: 'Organizations',
                to: { name: 'organizations' },
                },
                {
                text: 'Create Organization',
                active: true,
                },
            ],
        },
    },
    {
        path: '/master/organizations/:id',
        name: 'detail-organizations',
        props: true,
        component: () => import('@/views/master/organizations/detail.vue'),
        meta: {
            pageTitle: 'Detail Organization',
            breadcrumb: [
                {
                text: 'Organizations',
                to: { name: 'organizations' },
                },
                {
                text: 'Detail Organization',
                active: true,
                },
            ],
        },
    },
]